/* -------------------------------------------------------------------------- */
/*                                  Options                                   */
/* -------------------------------------------------------------------------- */

import { LanguageOption } from '@components/v2/ui/LanguageSelect/LanguageSelect';

export const ROLES_OPTIONS = [
	{
		label: 'roles.withDetails.SUPERADMIN',
		value: 'SUPERADMIN',
	},
	{ label: 'roles.withDetails.ADMIN', value: 'ADMIN' },
	{ label: 'roles.withDetails.USER', value: 'USER' },
	{ label: 'roles.withDetails.STAFF', value: 'STAFF' },
];

export const IMPORT_TYPE_OPTIONS = [
	{ label: 'global.productions', value: 'PRODUCTIONS' },
];

export const VERIFIED_FILTER_OPTIONS = [
	{ label: 'global.verified', value: true },
	{ label: 'global.unverified', value: false },
];

export const IPFS_STATUS_FILTER_OPTIONS = [
	{ label: 'global.notShared', value: true },
	{ label: 'global.shared', value: false },
];

export const ACTIVATED_FILTER_OPTIONS = [
	{ label: 'global.active', value: true },
	{ label: 'global.inactive', value: false },
];

export const MINT_STATUS_TRANSACTION_FILTER_OPTIONS = [
	{ label: 'In progress', value: 'IN_PROGRESS' },
	{ label: 'Pending', value: 'PENDING' },
	{ label: 'Error', value: 'ERROR' },
	{ label: 'Success', value: 'SUCCESS' },
	{ label: 'Bypassed', value: 'BYPASSED' },
];

export const IMPORT_STATUS_TRANSACTION_FILTER_OPTIONS = [
	{ label: 'In progress', value: 'IN_PROGRESS' },
	{ label: 'Pending', value: 'PENDING' },
	{ label: 'Error', value: 'ERROR' },
	{ label: 'Success', value: 'SUCCESS' },
	{ label: 'Bypassed', value: 'BYPASSED' },
	{ label: 'Rolled back', value: 'ROLLED_BACK' },
];

export const QUANTITY_CHECK_FILTER_OPTIONS = [
	{ label: 'global.onRange', value: 'OK' },
	{ label: 'global.underRange', value: 'UNDER_RANGE' },
	{ label: 'global.overRange', value: 'OVER_RANGE' },
];

export const MINT_STATUS_FILTER_OPTIONS = [
	{ label: 'global.Minted', value: 'MINTED' },
	{ label: 'global.Locked', value: 'LOCKED' },
	{ label: 'global.Available', value: 'AVAILABLE' },
	{ label: 'global.Destroyed', value: 'DESTROYED' },
];

export const PROJECTS_FILTER_OPTIONS = [
	{ label: 'Peebles & co', value: 'Peebles & co' },
	{ label: 'Hoffman Green', value: 'Hoffman Green' },
	{
		label: 'Hoffman Green Hoffman Green Peebles & co',
		value: 'Hoffman Green Hoffman Green Peebles & co',
	},
];

export const MONTHS_OPTIONS = [
	{ label: 'Weeks', value: 'Weeks' },
	{ label: 'Months', value: 'Months' },
	{ label: 'Years', value: 'Years' },
];

export const PRODUCTION_UNITS_OPTIONS = [
	{ label: 'kilowattheure', value: 'KWH' },
	{ label: 'mégawattheures', value: 'MWH' },
	{ label: 'Tonne ', value: 'T' },
	{ label: 'kilogramme ', value: 'KG' },
];

export const COUNTRIES_FILTER_OPTIONS = [
	{
		label: 'France',
		value: 'FR',
	},
	{
		label: 'England',
		value: 'EN',
	},
	{
		label: 'Italy',
		value: 'IT',
	},
	{
		label: 'Spain',
		value: 'SP',
	},
	{
		label: 'Germany',
		value: 'GR',
	},
	{
		label: 'Portugal',
		value: 'PT',
	},
];

export const PRODUCTION_CSV_COLUMNS_OPTIONS = [
	{
		label: 'startDate',
		value: 'startDate',
		required: true,
	},
	{
		label: 'quantity',
		value: 'quantity',
		required: true,
	},
	{
		label: 'meterPoint',
		value: 'meterPoint',
		required: true,
	},
	{
		label: 'endDate',
		value: 'endDate',
		required: false,
	},
	{
		label: 'proof',
		value: 'proof',
		required: false,
	},
	{
		label: 'conversionFactor',
		value: 'conversionFactorOverride',
		required: false,
	},
];

export const LANG_OPTIONS: LanguageOption[] = [
	{
		value: 'fr',
		label: 'Français',
		flagUrl: 'https://flagcdn.com/w80/fr.png',
	},
	{
		value: 'en',
		label: 'English',
		flagUrl: 'https://flagcdn.com/w80/gb.png',
	},
];
